(function () {
  var instances = {};

  function destroySwiper(sectionId) {
    var inst = instances[sectionId];
    if (inst && typeof inst.destroy === 'function') inst.destroy(true, true);
    delete instances[sectionId];
  }

  function initSwiper(sectionId) {
    if (instances[sectionId]) return;
    var el = document.getElementById('is-swiper-' + sectionId);
    if (!el) return;

    if (typeof window.Swiper === 'undefined') {
      setTimeout(function () { initSwiper(sectionId); }, 50);
      return;
    }

    instances[sectionId] = new Swiper(el, {
      slidesPerView: 1.499,
      spaceBetween: 20,
      centeredSlides: false,
      loop: true,
      speed: 500,
      autoplay: false,
      navigation: {
        nextEl: document.getElementById('is-next-' + sectionId),
        prevEl: null
      },
      breakpoints: {
        480: { slidesPerView: 3.2, spaceBetween: 14 },
        769: { slidesPerView: 4.5, spaceBetween: 16 },
        1025: { slidesPerView: 5.5, spaceBetween: 16 },
        1280: { slidesPerView: 5.39, spaceBetween: 20 }
      }
    });
  }

  function initAll() {
    document.querySelectorAll('.image-slider[data-section-id]').forEach(function (el) {
      initSwiper(el.dataset.sectionId);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll, { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:unload', function (e) {
    if (e.detail) destroySwiper(e.detail.sectionId);
  });

  document.addEventListener('shopify:section:load', function (e) {
    if (e.detail) {
      destroySwiper(e.detail.sectionId);
      initSwiper(e.detail.sectionId);
    }
  });
})();
